import { Head, useForm } from "@inertiajs/react";
import ActivationCard from "@/components/parents/ActivationCard";
import ChildMatchCard from "@/components/parents/ChildMatchCard";
import ParentLayout from "@/components/parents/ParentLayout";

/**
 * Adding another child when already signed in: enter the code, then
 * confirm the student it matched before they're linked.
 */
export default function ClaimChild({
  claim_code, submit_path,
  school_name, siblings, claim_another_path, user_contexts,
  confirm,
}) {
  return (
    <ParentLayout
      school_name={school_name}
      siblings={siblings}
      claim_another_path={claim_another_path}
      user_contexts={user_contexts}
      title={confirm ? "Is this your child?" : "Activate another child"}
      activeClaim
    >
      <Head title={confirm ? "Confirm your child" : "Activate another child"} />
      <div className="max-w-lg">
        {confirm ? (
          <ConfirmStep confirm={confirm} confirmPath={`${submit_path.replace(/\/?$/, "")}/confirm`} />
        ) : (
          <EntryStep claimCode={claim_code} submitPath={submit_path} />
        )}
      </div>
    </ParentLayout>
  );
}

function EntryStep({ claimCode, submitPath }) {
  const { data, setData, post, processing, errors } = useForm({ claim_code: claimCode || "" });
  const submit = (e) => {
    e.preventDefault();
    post(submitPath);
  };

  return (
    <ActivationCard
      claim_code={data.claim_code}
      onChange={(field, value) => setData(field, value)}
      onSubmit={submit}
      processing={processing}
      errors={{ claim_code: errors.claim_code }}
      variant="embedded"
      submitLabel="Find my child"
      showEmail={false}
    />
  );
}

function ConfirmStep({ confirm, confirmPath }) {
  const form = useForm({ claim_code: confirm.claim_code, privacy_consent: false });
  const submit = (e) => {
    e.preventDefault();
    form.post(confirmPath);
  };

  return (
    <ChildMatchCard
      student={confirm.student}
      form={form}
      onSubmit={submit}
      cancelHref="/activate"
      requireConsent
      consentId="signed_in_parent_privacy_consent"
    />
  );
}
